import { render } from "./PermissionConfirm.vue?vue&type=template&id=93a1e982&scoped=true&ts=true"
import script from "./PermissionConfirm.vue?vue&type=script&lang=ts"
export * from "./PermissionConfirm.vue?vue&type=script&lang=ts"

import "./PermissionConfirm.vue?vue&type=style&index=0&id=93a1e982&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a1e982"]])

export default __exports__